const supportedLocales = ['es', 'pt'];

module.exports = { supportedLocales };
